import { Modal, Box, Typography, List, Stack } from "@mui/material"
import { useState } from "react";
import { ModalCatalogsStyles } from "./ModalCatalogs/ModalCatalogsStyles";

export const ModalEntityWithErrors = ({entityWithErrors, typeEntity}) => {
    const[openModal, setOpenModal] = useState(true)
    
    const handleCloseModal = () => {
        setOpenModal(false)
    }

    const ModalBodyProductsContent = () => {
        return (
            <>
                <List>
                {entityWithErrors.map((product, index) => (
                    <Stack sx={{marginBottom: "10px"}} key={index}>
                        <Typography component="h2" variant="body1" sx={{textTransform: "uppercase", fontWeight: "bold"}}>
                            Product: {index}
                        </Typography>
                        <Typography component="span" variant="body2">
                            Customer: {product.customer}
                        </Typography>
                        <Typography component="span" variant="body2">
                            Material: {product.material}
                        </Typography>
                        <Typography component="span" variant="body2">
                            Plant: {product.plant}
                        </Typography>
                    </Stack>
                ))}
                </List>
            </>
        )
    }

    const ModalBodyProvidenceContent = () => {
        return (
            <>
                <List>
                {entityWithErrors.map((province, index) => (
                    <Stack sx={{marginBottom: "10px"}} key={index}>
                        <Typography component="h2" variant="body1" sx={{textTransform: "uppercase", fontWeight: "bold"}}>
                            Province: {index}
                        </Typography>
                        <Typography component="span" variant="body2">
                            Province: {province.province}
                        </Typography>
                        <Typography component="span" variant="body2">
                            Plant: {province.plant}
                        </Typography>
                    </Stack>
                ))}
                </List>
            </>
        )
    }

    return (
        <Modal
            open={openModal}
            onClose={handleCloseModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            >
            <Box sx={ModalCatalogsStyles.boxModal} component="div">
                <Typography id="modal-modal-title" variant="h6" component="h2">
                    These {typeEntity} entities has could not be saved as they exist in the database
                </Typography>
                {typeEntity === "templateModel" && (
                    <ModalBodyProductsContent />
                )}
                {typeEntity === "templateProvince" && (
                    <ModalBodyProvidenceContent />
                )}
            </Box>
        </Modal>
    )
}